import GridImageDefaultProps from "segments/desktop/core-components/grid-image/default-props";
import titleDefaultProps from "segments/desktop/core-components/title/default-props";
import paragraphDefaultProps from "segments/desktop/core-components/paragraph/default-props";

export default {
  ...{ ...GridImageDefaultProps, src: "/static/img/segment-layout-default-images/grid/man-with-blue-shirt.png" },
  fullParagraph: { ...titleDefaultProps, ...paragraphDefaultProps }
};
